<div class="container mx-auto px-4 py-6">
  <div class="mb-6 flex items-center justify-between">
    <div>
      <h1 class="text-3xl font-bold text-gray-800">Painel de Assinaturas</h1>
      <p class="text-gray-600 mt-2">Administração completa de assinatura, vencimento e status financeiro</p>
    </div>
    <div class="flex gap-2">
      <a routerLink="/admin/financeiro/historico" class="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50">Ver Histórico</a>
      <button (click)="goToRegistrarPagamento()" class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700">Registrar Pagamento</button>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
    <div class="bg-green-50 border border-green-200 rounded-lg p-4">
      <div class="text-sm text-green-700">Ativas</div>
      <div class="text-2xl font-bold text-green-800">{{ activeCount }}</div>
    </div>
    <div class="bg-amber-50 border border-amber-200 rounded-lg p-4">
      <div class="text-sm text-amber-700">Vencendo em até 7 dias</div>
      <div class="text-2xl font-bold text-amber-800">{{ dueSoonCount }}</div>
    </div>
    <div class="bg-red-50 border border-red-200 rounded-lg p-4">
      <div class="text-sm text-red-700">Vencidas</div>
      <div class="text-2xl font-bold text-red-800">{{ overdueCount }}</div>
    </div>
  </div>

  <div class="bg-white rounded-lg shadow p-6 mb-6">
    <div class="grid grid-cols-1 md:grid-cols-6 gap-4">
      <div class="md:col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-1">Buscar</label>
        <input [(ngModel)]="search" (input)="onFilterChange()" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="Fornecedor, ID fornecedor ou ID assinatura">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Status</label>
        <select [(ngModel)]="status" (change)="load()" class="w-full px-3 py-2 border border-gray-300 rounded-md">
          <option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</option>
        </select>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Plano</label>
        <select [(ngModel)]="planFilter" (change)="onFilterChange()" class="w-full px-3 py-2 border border-gray-300 rounded-md">
          <option *ngFor="let opt of planOptions" [value]="opt.value">{{ opt.label }}</option>
        </select>
      </div>
      <div *ngIf="status === 'vencendo'">
        <label class="block text-sm font-medium text-gray-700 mb-1">Dias para vencimento</label>
        <input [(ngModel)]="dias" (change)="load()" type="number" class="w-full px-3 py-2 border border-gray-300 rounded-md">
      </div>
      <div class="flex items-end">
        <button (click)="clearFilters()" class="w-full px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50">Limpar filtros</button>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="bg-white rounded-lg shadow overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fornecedor</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Plano</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Expiração</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Dias Restantes</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pagamento</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Auto Renew</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Leads</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Valor</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let a of filteredItems" class="hover:bg-gray-50">
            <td class="px-6 py-4">
              <div class="text-sm font-medium text-gray-900">{{ a.fornecedor.nome }}</div>
              <div class="text-xs text-gray-500">ID: {{ a.fornecedor.id }}</div>
            </td>
            <td class="px-6 py-4">{{ getPlanLabel(a.planLevel) }}</td>
            <td class="px-6 py-4">{{ (a.subscriptionExpiresAt || a.proximoVencimento) ? ((a.subscriptionExpiresAt || a.proximoVencimento) | date: 'dd/MM/yyyy') : '—' }}</td>
            <td class="px-6 py-4">{{ a.diasParaVencimento ?? '—' }}</td>
            <td class="px-6 py-4">
              <span class="px-2 py-1 rounded text-xs font-medium" [ngClass]="getStatusClass(a)">
                {{ normalizeStatus(a) }}
              </span>
            </td>
            <td class="px-6 py-4">{{ getPaymentMethodLabel(a.paymentMethod) }}</td>
            <td class="px-6 py-4">{{ a.autoRenew === true ? '✅ Sim' : a.autoRenew === false ? '❌ Não' : '—' }}</td>
            <td class="px-6 py-4">{{ a.leadCount ?? '—' }}</td>
            <td class="px-6 py-4">{{ (a.valorMensal ?? a.valor) ? ((a.valorMensal ?? a.valor) | currency:'BRL') : '—' }}</td>
            <td class="px-6 py-4">
              <div class="flex flex-col gap-1 text-xs">
                <button (click)="openFornecedor(a)" class="text-indigo-600 hover:text-indigo-800 text-left">Ver fornecedor</button>
                <button (click)="openEditFornecedor(a)" class="text-blue-600 hover:text-blue-800 text-left">Editar assinatura</button>
                <button (click)="goToRegistrarPagamento(a)" class="text-green-600 hover:text-green-800 text-left">Registrar pagamento</button>
              </div>
            </td>
          </tr>
          <tr *ngIf="filteredItems.length === 0">
            <td colspan="11" class="px-6 py-10 text-center text-gray-500">Nenhuma assinatura encontrada para os filtros selecionados.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="bg-white px-4 py-3 border-t border-gray-200 sm:px-6">
      <div class="flex items-center justify-between">
        <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
          <div>
            <p class="text-sm text-gray-700">
              Mostrando
              <span class="font-medium">{{ (page - 1) * pageSize + 1 }}</span>
              até
              <span class="font-medium">{{ displayEnd() }}</span>
              de
              <span class="font-medium">{{ filteredItems.length }}</span>
              resultados
            </p>
          </div>
          <div>
            <app-pagination [page]="page" [pageSize]="pageSize" [total]="total" (pageChange)="onPageChange($event)"></app-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
